import {Box, BoxProps, Text} from '@chakra-ui/react'
import {ReactNode} from 'react'
import {LuCircleAlert} from 'react-icons/lu'

interface Props extends BoxProps {
  message: ReactNode
}

export function AlertBox({message, ...props}: Props) {
  return (
    <Box bgColor="red.subtle" display="flex" p="4" borderRadius="md" gap="3" width="100%" textAlign="start" {...props}>
      <Box>
        <LuCircleAlert size="18" color="#92310A" />
      </Box>
      <Box>
        <Text fontWeight="medium" color="red.fg">
          {message}
        </Text>
      </Box>
    </Box>
  )
}
